/** The API announces a refusal; stores own the resulting state change. */
const listeners = new Set<(slug: string) => void>();

export function subscribeToWorkspaceSuspension(listener: (slug: string) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** A subscriber must not prevent the suspension redirect or replace the API error. */
export function publishWorkspaceSuspended(slug: string): void {
  for (const listener of listeners) {
    try {
      listener(slug);
    } catch (error) {
      console.error("[api] workspace suspension listener failed", { slug, error });
    }
  }
}
